export default "__VITE_ASSET__B$TVGVef__"